// 7.1.13 ToObject(argument)
var defined = require('./$.defined');
module.exports = function(it){
  return Object(defined(it));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-attrs-filter/~/core-js/library/modules/$.to-object.js
// module id = 1598
// module chunks = 0